import React from 'react';
import PropTypes from 'prop-types';
import styles from './ProgressBar.module.scss';

const ProgressBar = ({ value, max, variant, showLabel, className, ...rest }) => {
  const percent = Math.min(100, Math.max(0, (value / max) * 100));

  const classNames = [
    styles.track,
    className || '',
  ]
    .filter(Boolean)
    .join(' ');

  const fillClassNames = [
    styles.fill,
    styles[variant],
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classNames} role="progressbar" aria-valuenow={value} aria-valuemin={0} aria-valuemax={max} {...rest}>
      <div
        className={fillClassNames}
        style={{ width: `${percent}%` }}
      />
      {showLabel && (
        <span className={styles.label}>{Math.round(percent)}%</span>
      )}
    </div>
  );
};

ProgressBar.propTypes = {
  value: PropTypes.number.isRequired,
  max: PropTypes.number,
  variant: PropTypes.oneOf(['primary', 'success', 'warning', 'danger']),
  showLabel: PropTypes.bool,
  className: PropTypes.string,
};

ProgressBar.defaultProps = {
  max: 100,
  variant: 'primary',
  showLabel: false,
  className: '',
};

export default ProgressBar;
